export const isTravel = (businessUnitCode: string): boolean =>
  ["travel-insurance-br", "travel-insurance-cl", "travel-insurance-co"].indexOf(
    businessUnitCode
  ) !== -1;
